<template>
	<div>
		<div class="mainCont">
			<div class="headTabs">
				<el-tabs v-model="activeTab">
					<el-tab-pane label="聚合解析链接" value="1" name="1"></el-tab-pane>
					<el-tab-pane label="三方回传链接" value="2" name="2"></el-tab-pane>
					<el-tab-pane label="预算占比分析" value="3" name="3"></el-tab-pane>
				</el-tabs>
			</div>
			<!-- keep-alive：切换 tab 时缓存子组件实例，避免 v-if 销毁重建导致筛选丢失与重复请求 mounted -->
			<keep-alive>
				<aggregationAnalysLink v-if="activeTab === '1'" key="sourceAnalysis-aggregation" />
				<thirdPartyAnalysisLink v-if="activeTab === '2'" key="sourceAnalysis-thirdParty" />
				<budgetProportionAnalysis v-if="activeTab === '3'" key="sourceAnalysis-budgetProportion" />
			</keep-alive>
		</div>
	</div>
</template>

<script>
	import aggregationAnalysLink from './aggregationAnalysLink.vue';
	import thirdPartyAnalysisLink from './thirdPartyAnalysisLink.vue';
	import budgetProportionAnalysis from './budgetProportionAnalysis.vue';

	export default {
		name: "TimeShareReport",
		components: {
			aggregationAnalysLink,
			thirdPartyAnalysisLink,
			budgetProportionAnalysis,
		},
		data() {
			return {
				activeTab: '1', // 当前选中的素材分析选项卡
			}
		},
	}
</script>

<style scoped>
	.mainCont {
		/* background: #FFFFFF; */
		border-radius: 4px;
		margin-top: 0px;
		padding: 20px 10px;
		padding-top: 0;
		box-sizing: border-box;
	}

	.headTabs {
		padding: 0 20px;
		padding-top: 10px;
		margin: 10px 0;
		font-size: 16px;
		background: #ffffff;
	}
	.headTabs /deep/ .el-tabs__item{
		font-size: 16px;
	}
</style>
